import { render, staticRenderFns } from "./OfficeTransfersSidebar.vue?vue&type=template&id=710ae9a0&scoped=true&"
import script from "./OfficeTransfersSidebar.vue?vue&type=script&lang=js&"
export * from "./OfficeTransfersSidebar.vue?vue&type=script&lang=js&"
import style0 from "./OfficeTransfersSidebar.vue?vue&type=style&index=0&id=710ae9a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710ae9a0",
  null
  
)

export default component.exports